export default {
  TOUR: 'tour',
  EXPERIENCE: 'experience',
  INFORMATION: 'information'
}